import { useState } from "react";
import type { Question } from "@/domain/entities";
import { isTimePeriod, TIME_PERIOD_OPTIONS } from "@/domain/scenario/timePeriods";
import { Button } from "../Button";
import { useLocale } from "../../i18n/LocaleProvider";
import { SubmitRow } from "./SubmitRow";
import styles from "./questions.module.css";

type TimeQuestion = Extract<Question, { type: "time" }>;

interface Props {
  question: TimeQuestion;
  value: string | undefined;
  optional: boolean;
  onSubmit: (value: string | undefined) => void;
}

/** Exact "HH:mm"; with `periods` a time of day can be tapped instead. */
export function TimeInput({ question, value, optional, onSubmit }: Props) {
  const { t, pick } = useLocale();
  const [text, setText] = useState(value !== undefined && !isTimePeriod(value) ? value : "");
  return (
    <div className={styles.stack}>
      {question.periods && (
        <div className={styles.row}>
          {TIME_PERIOD_OPTIONS.map((option) => (
            <Button key={option.id} selected={value === option.id} onClick={() => onSubmit(option.id)}>
              {pick(option.text)}
            </Button>
          ))}
        </div>
      )}
      {question.periods && <span className={styles.labels}>{t.questionnaire.exactTime}</span>}
      <input
        className={styles.field}
        type="time"
        aria-label={pick(question.text)}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <SubmitRow onNext={() => onSubmit(text)} onSkip={optional ? () => onSubmit(undefined) : undefined} />
    </div>
  );
}
